import { BusinessContact } from './businesscontact.model';
import { SecretQuestion } from './secretQuestion.model';
import { UserActivationStatus } from './useractivationstatus.model';
import { CorporateEntity } from "./corporateEntity.model";
import { DefaultLandingPage } from "./defaultLandingPages";
import { Culture } from "./Culture";
import { DateUtil } from "../common/date";
import * as Model from "../app.model";
import * as _ from 'underscore';
import { UserAcceptanceData } from './UserAcceptanceData.model';
import { UserLoginGroup } from './userLoginGroup.model';
import { IValidationMessages } from '../common/error/error.model';
import { ErrorCode } from '../common/error/errorcode.enum';
import { isArray, find, isEmpty, map } from 'underscore';
import { Country } from './country';


export class User {
    public Id: number = 0;
    public BCId: number = 0;
    public DefaultLandingPageId: number = 0;
    public BusinessContact: BusinessContact;
    public UserAcceptanceData: UserAcceptanceData;
    public UserActivationStatus: UserActivationStatus;
    public LastLogOn: Date | string = "";
    public LoginName: string = "";
    public CreatedBy: number = 0;
    public CreatedOn: Date | string = "";
    public UpdatedBy: string;
    public UpdatedOn: Date | string = "";
    public Password: string;
    public LoginGroup: UserLoginGroup;
    public CorporateEntity: CorporateEntity;
    public SelectedSecretQuestions: Array<SecretQuestion> = [];
    public DefaultLandingPage: DefaultLandingPage;
    public ErrorMessages: Array<IValidationMessages> = [];
    public IsAccountSetUpDone: boolean;
    public Region: string = "";
    public Culture: Culture;
    public PreferredCultureCode: string = "";
    public ResultData: string = "";
    public Country: Country;
    public SecondaryPhoneCountry: Country;
    public Clar_Language : any;
    public Clar_Language_list : any;

    constructor(user: User) {
        this.Id = user.Id || 0;
        this.BCId = user.BCId || 0;
        this.Region = user.Region||"";
        this.LoginName = user.LoginName || "";
        this.CreatedBy = user.CreatedBy || 0;
        this.UpdatedBy = user.UpdatedBy || "";
        this.Password = user.Password || "";
        this.DefaultLandingPageId = user.DefaultLandingPageId || 0;
        this.PreferredCultureCode = user.PreferredCultureCode || "";

        if (user.BusinessContact)
            this.BusinessContact = new BusinessContact(user.BusinessContact);
        else
            this.BusinessContact = new BusinessContact({} as BusinessContact);

        if (user.UserAcceptanceData)
            this.UserAcceptanceData = new UserAcceptanceData(user.UserAcceptanceData);
        else
            this.UserAcceptanceData = new UserAcceptanceData({} as UserAcceptanceData);

        if (_.isArray(user.SelectedSecretQuestions)) {
            this.SelectedSecretQuestions = _.map(user.SelectedSecretQuestions, (sq) => { return new SecretQuestion(sq) });
        } else {
            this.SelectedSecretQuestions = [];
        }

        if (user.LoginGroup) {
            this.LoginGroup = new UserLoginGroup(user.LoginGroup);
        } else {
            this.LoginGroup = new UserLoginGroup({} as UserLoginGroup);
        }

        if (user.DefaultLandingPage)
            this.DefaultLandingPage = new DefaultLandingPage(user.DefaultLandingPage);
        else
            this.DefaultLandingPage = new DefaultLandingPage({} as DefaultLandingPage);
        if (user.UserActivationStatus)
            this.UserActivationStatus = new UserActivationStatus(user.UserActivationStatus);
        else
            this.UserActivationStatus = new UserActivationStatus({} as UserActivationStatus);

        if (user.CorporateEntity)
            this.CorporateEntity = new CorporateEntity(user.CorporateEntity);
        else
            this.CorporateEntity = new CorporateEntity({} as CorporateEntity);

        this.IsAccountSetUpDone = this.LoginName == "Account Setup Not Complete";

        this.CreatedOn = DateUtil.ConvertToLocalTimeZone(user.CreatedOn);
        this.UpdatedOn = DateUtil.ConvertToLocalTimeZone(user.UpdatedOn);
        this.LastLogOn = DateUtil.ConvertToLocalTimeZone(user.LastLogOn);
        this.ResultData = user.ResultData;
    }

    validate() {
        this.ErrorMessages = [];
        if (!this.LoginGroup.Group || this.LoginGroup.Group.Id <= 0)
            this.ErrorMessages.push({ Key: ErrorCode.USER_VALIDATION_GROUPNOTASSIGNED });
    }

    validateSecretQuestions() {
        this.ErrorMessages = [];

        if (isArray(this.SelectedSecretQuestions) && this.SelectedSecretQuestions.length == 2) {

            //ANY QUESTION/ANSWER EMPTY ////DUPLICATE QUESTIONS
            let sq = find(this.SelectedSecretQuestions, function (sq) {
                return (isEmpty(sq.Question) || isEmpty(sq.Answer))
            });

            if (sq != undefined)
                this.ErrorMessages.push({ Key: ErrorCode.USERSETUP_VALIDATION_BOTHSECURITYQUESTIONSHAVETOBEANSWERED });
            else if (this.SelectedSecretQuestions[0].Question === this.SelectedSecretQuestions[1].Question)
                this.ErrorMessages.push({ Key: ErrorCode.USERSETUP_VALIDATION_SAMESECURITYQUESTIONSSELECTED });
        } else if (isArray(this.SelectedSecretQuestions) && this.SelectedSecretQuestions.length == 1) {
            //Valuenet-26838
            this.ErrorMessages.push({ Key: ErrorCode.USERSETUP_VALIDATION_BOTHSECURITYQUESTIONSHAVETOBEANSWERED });
        }
        //Valuenet-26838
        //else {
        //    this.ErrorMessages.push({ Key: ErrorCode.USERSETUP_VALIDATION_BOTHSECURITYQUESTIONSHAVETOBEANSWERED });
        //}
    }
}
